<template>
    <Row :gutter="16">
        <Col span="6">
        <FormItem label="高度">
            <Input v-model="descJson.gaoDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="冠幅">
            <Input v-model="descJson.guanFu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="株高">
            <Input v-model="descJson.zhuGao"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="叶片数">
            <Input v-model="descJson.yePianShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="不正常叶数">
            <Input v-model="descJson.buZhengChangYeShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="根系状态">
            <Input v-model="descJson.genXiZhuangTai"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="弯曲度">
            <Input v-model="descJson.wanQuDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="重量">
            <Input v-model="descJson.zhongLiang"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="花苞数">
            <Input v-model="descJson.huaBaoShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="高度差茎秆">
            <Input v-model="descJson.gaoDuChaJingGan"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="病虫害">
            <Input v-model="descJson.bingChongHai"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="土壤湿度">
            <Input v-model="descJson.tuRangShiDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="开放度">
            <Input v-model="descJson.kaiFangDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="机械损伤">
            <Input v-model="descJson.jiXieSunShang"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="株数">
            <Input v-model="descJson.zhuShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="花数">
            <Input v-model="descJson.huaShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="枝条数">
            <Input v-model="descJson.zhiTiaoShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="节间高度">
            <Input v-model="descJson.jieJianGaoDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="芽数">
            <Input v-model="descJson.yaShu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="粗度">
            <Input v-model="descJson.chuDu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="球茎">
            <Input v-model="descJson.qiuJing"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="花型">
            <Input v-model="descJson.huaXing"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>

        <Col span="6">
        <FormItem label="叶幅">
            <Input v-model="descJson.yeFu"
                :readonly="readOnly"></Input>
        </FormItem>
        </Col>
    </Row>
</template>

<script>
import { getDefaultStandardCardDesc } from '@/view/product-management/standardCard-management/StandardCardDescType';

export default {
    name: 'StandardCardFormItems',
    model: {
        prop: 'descVal',
        event: 'change'
    },
    props: {
        descVal: {
            type: Object,
            default: () => {
                return getDefaultStandardCardDesc;
            }
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            descJson: getDefaultStandardCardDesc()
        };
    },
    watch: {
        descVal: {
            deep: true,
            handler: function (newValue, oldVal) {
                this.descJson = Object.assign(this.descJson, newValue);
            }
        },
        descJson: {
            deep: true,
            handler: function (newValue, oldVal) {
                this.$emit('change', newValue);
            }
        }
    }
};
</script>

<style scoped>

</style>
